import {
  Stack,
  Typography,
  Button,
  Card,
  CardContent,
  Box,
  Divider,
  Link,
} from "@mui/material";
import logoHeader from "../../../assets/fluxmed-logo-horizontal.png";
import { ContentBoxTitle } from "../../../components/common";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from "@mui/icons-material/Info";
import PaymentsIcon from "@mui/icons-material/Payments";
import PeopleIcon from "@mui/icons-material/People";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Check, Message } from "@mui/icons-material";

interface PlanTypeSelectionProps {
  onSelectPlanType: (planType: "subscription" | "fluxpay") => void;
}

export function PlanTypeSelection({
  onSelectPlanType,
}: PlanTypeSelectionProps) {
  return (
    <Stack alignItems="center" spacing={6}>
      <Stack alignItems="center" spacing={2}>
        <ContentBoxTitle>Selecione o plano de sua escolha</ContentBoxTitle>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={4}
        sx={{ width: "100%", maxWidth: "900px" }}
      >
        {/* Card do Plano de Assinatura */}
        <Card
          elevation={3}
          sx={{
            flex: 1,
            borderRadius: "12px",
            transition: "transform 0.2s",
            "&:hover": { transform: "scale(1.02)" },
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <Box
              sx={{
                p: 3,
                bgcolor: "primary.main",
                color: "white",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
              }}
            >
              <Typography variant="h5" align="center" fontWeight="500">
                Planos de Assinatura
              </Typography>
            </Box>

            <Box sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Typography variant="body1" fontWeight="500" align="center">
                  Assinatura mensal com valores fixos
                </Typography>

                <Divider />

                <Stack spacing={1.5}>
                  <Box display="flex" alignItems="center">
                    <PeopleIcon color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Opções para diferentes tamanhos de clínicas
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <AttachMoneyIcon color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Valores mais acessíveis para clínicas menores
                    </Typography>
                  </Box>


                  <Box display="flex" alignItems="center">
                    <CheckIcon color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Sem limite de consultas mensais
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <CheckIcon color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Acesso a todas as funcionalidades básicas
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <InfoIcon color="secondary" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Extensões fluxmed disponíveis
                    </Typography>
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width="100%"
                    pt={1}
                  >
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="secondary"
                    >
                      <Link
                        href="https://fluxmed.com.br"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Saiba mais
                      </Link>
                    </Typography>
                  </Box>
                </Stack>
              </Stack>
            </Box>

            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => onSelectPlanType("subscription")}
                sx={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "1rem",
                  textTransform: "none",
                  minWidth: "200px",
                }}
              >
                Escolher Assinatura
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* Card do FluxPay */}
        <Card
          elevation={3}
          sx={{
            flex: 1,
            borderRadius: "12px",
            transition: "transform 0.2s",
            "&:hover": { transform: "scale(1.02)" },
          }}
        >
          <CardContent sx={{ p: 0 }}>
            <Box
              sx={{
                p: 3,
                bgcolor: "secondary.main",
                color: "white",
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
              }}
            >
              <Typography variant="h5" align="center" fontWeight="500">
                Plano FluxPay
              </Typography>
            </Box>

            <Box sx={{ p: 3 }}>
              <Stack spacing={2}>
                <Typography variant="body1" fontWeight="500" align="center">
                  Pagamento por consulta realizada paga
                </Typography>

                <Divider />

                <Stack spacing={1.5}>
                  <Box display="flex" alignItems="center">
                    <CreditCardIcon color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Processamento de pagamentos instantâneo
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center">
                    <Message color="success" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Envie cobranças por WhatsApp
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <Check color="primary" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Limite de 10 profissionais
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <InfoIcon color="secondary" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Taxa de R$3,50 por consulta
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center">
                    <InfoIcon color="secondary" sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      Requer conta PJ no Mercado Pago
                    </Typography>
                  </Box>

                  <Box display="flex" alignItems="center" justifyContent="center" width="100%" pt={1}>
                    <Typography variant="body1" fontWeight="500">
                      <Link
                        href="https://fluxmed.com.br/intergracao-com-o-mercado-pago/"
                        target="_blank"
                        rel="noopener noreferrer"
                        color="primary"
                      >
                        Saiba mais sobre o FluxPay
                      </Link>
                    </Typography>
                  </Box>
                </Stack>
              </Stack>
            </Box>

            <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() => onSelectPlanType("fluxpay")}
                sx={{
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "1rem",
                  textTransform: "none",
                  minWidth: "200px",
                }}
              >
                Escolher FluxPay
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
}
